import React from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { IntlProvider } from "react-intl";
import { useMount } from "react-use";
import { Observer } from "mobx-react";
import { useStores } from "./hooks";
import Main from "./pages/Main";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Cust from "./pages/Cust";
import Book from "./pages/Book";
import Debug from "./pages/Debug";
import Open from "./pages/Open";
import AdminIn from "./pages/AdminIn";
import zh_TW from "./locale/zh-TW";
import en_US from "./locale/en-US";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const langMap = new Map<string, any>([
  ["zh-TW", zh_TW],
  ["en-US", en_US],
]);

type ProtectedRouteProps = {
  auth: boolean;
  children: any;
};

const ProtectedRoute = ({ auth, children }: ProtectedRouteProps) => {
  const location = useLocation();
  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
};

function App() {
  const { sessionStore } = useStores();

  useMount(() => {
    if (document.body.getAttribute("listener") !== "true") {
      document.body.setAttribute("listener", "true");
      document.addEventListener("keydown", (e) => {
        if (e.key === undefined) {
          return;
        }
        if (e.key === "Enter") {
          sessionStore.privateHandler(sessionStore.privateInput);
          sessionStore.privateInput = "";
        } else if (e.key.length === 1 && /[a-zA-Z0-9]/.test(e.key)) {
          sessionStore.privateInput = sessionStore.privateInput + e.key;
        }
      });
    }
  });

  return (
    <Observer>
      {() => {
        return (
          <IntlProvider
            locale={sessionStore.locale}
            messages={langMap.get(sessionStore.locale)}
          >
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Main />} />
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/debug" element={<Debug />} />
                <Route path="/book" element={<Book />} />
                <Route
                  path="/admin/in"
                  element={
                    <ProtectedRoute auth={sessionStore.isAdmin}>
                      <AdminIn />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/cust"
                  element={
                    <ProtectedRoute auth={sessionStore.isLogin}>
                      <Cust />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/open"
                  element={
                    <ProtectedRoute auth={sessionStore.isLogin}>
                      <Open />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </BrowserRouter>
          </IntlProvider>
        );
      }}
    </Observer>
  );
}

export default App;
